"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Standard["default"];
  }
});
var _Standard = _interopRequireDefault(require("./Standard"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }